import React from 'react';
import Auth from './Auth';
import {Redirect} from 'react-router-dom';

export default () => {
    const auth = new Auth();
    auth.handleAuthentication();
    return  <Redirect to='/'/>
}
